import { Link } from "@tanstack/react-router";
import { Trans } from "react-i18next";

const linkClass = "text-accent underline-offset-2 hover:underline";

/**
 * The line under a sign-up button naming the documents the person agrees to. The links open in a
 * new tab so a half-filled form is not lost.
 */
export function LegalConsent({ i18nKey }: { i18nKey: "auth.signup.agree" | "auth.invite.agree" }) {
  return (
    <p className="text-center text-xs text-ink-2">
      <Trans
        i18nKey={i18nKey}
        components={{
          terms: (
            <Link
              to="/legal/$doc"
              params={{ doc: "terms" }}
              target="_blank"
              rel="noopener"
              className={linkClass}
            />
          ),
          aup: (
            <Link
              to="/legal/$doc"
              params={{ doc: "acceptable-use" }}
              target="_blank"
              rel="noopener"
              className={linkClass}
            />
          ),
        }}
      />
    </p>
  );
}
